import { useMemo, useRef } from "react";
import StepperTabPanel from "@components/StepperTabs/StepperTabPanel";
import StepperTabs from "@components/StepperTabs/StepperTabs";
import { STEPPER_TYPE, type StepperTabsHandle } from "@components/StepperTabs/StepperTabs.types";
import type { VesselCallStatusContextType } from "@features/vessel-call/vessel-call-status/VesselCallStatus";
import { paths } from "@utils/navigation";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router-dom";

const LANG_BASE = "vessel-call.operations";
const { plda, cargoOperations } = paths.vesselCall.operations;

const OperationsLiquidBulk = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const stepperTabsRef = useRef<StepperTabsHandle>(null);
  const outletCtx = useOutletContext<VesselCallStatusContextType>();
  const steps = useMemo(
    () => [
      {
        label: `${LANG_BASE}.plda`,
        path: plda,
      },
      {
        label: `${LANG_BASE}.cargo-operations`,
        path: cargoOperations,
      },
    ],
    [],
  );
  const activeIndex = useMemo(() => {
    const p = location.pathname;
    const i = steps.findIndex((s) => p.endsWith(`/${s.path}`));
    return i === -1 ? 0 : i;
  }, [location.pathname, steps]);

  return (
    <div className="pb-8 w-[100%] mx-0 max-w-[100%] overflow-x-auto flex flex-col box-border">
      <StepperTabs
        ref={stepperTabsRef}
        testId="operations-liquid-bulk-stepper-tabs"
        currentStepIndex={activeIndex}
        stepperType={STEPPER_TYPE.HORIZONTAL}
        isTypeChangeable={false}
        onStepperTabChange={(index) => {
          if (index !== activeIndex) {
            navigate({
              pathname: steps[index].path,
            });
            window.scrollTo({ top: 0, behavior: "smooth" });
          }
        }}
      >
        {steps.map((s) => (
          <StepperTabPanel key={s.path} label={t(`${s.label}`)}>
            <div className="min-w-full flex flex-col bg-white">
              <Outlet context={outletCtx} />
            </div>
          </StepperTabPanel>
        ))}
      </StepperTabs>
    </div>
  );
};

export default OperationsLiquidBulk;
